import type { RefObject } from 'react';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { useComparisonMode } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { Capacity } from '../../main-section/capacity/capacity';
import { InitiativeCompletion } from '../../main-section/initiative-completion/initiative-completion';
import { InitiativeFocus } from '../../main-section/initiative-focus/initiative-focus';
import { InitiativeOverview } from '../../main-section/initiative-overview/initiative-overview';
import { KeyMeasuresOverTime } from '../../main-section/key-measures-over-time/key-measures-over-time';
import { MeasureComparison } from '../../main-section/measure-comparison/measure-comparison';
import { MonthlyAverages } from '../../main-section/monthly-averages/monthly-averages';
import { ComparisonMode, MultipleViewMode, ViewMode } from '../../process-analysis.type';

export const MainSectionContent = ({ chartRef }: { chartRef: RefObject<HTMLDivElement | null> }) => {
  const viewMode = useProcessAnalysisStore((state) => state.viewMode);
  const multipleViewMode = useProcessAnalysisStore((state) => state.multipleViewMode);
  const comparisonMode = useComparisonMode();

  if (comparisonMode === ComparisonMode.Single) {
    switch (viewMode) {
      case ViewMode.MeasureComparison:
        return <MeasureComparison chartRef={chartRef} />;
      case ViewMode.Capacity:
        return <Capacity />;
      case ViewMode.InitiativeOverview:
        return <InitiativeOverview />;
      case ViewMode.InitiativeCompletion:
        return <InitiativeCompletion chartRef={chartRef} />;
      case ViewMode.InitiativeFocus:
        return <InitiativeFocus chartRef={chartRef} />;
      default:
        return null;
    }
  }

  if (comparisonMode === ComparisonMode.Multiple) {
    switch (multipleViewMode) {
      case MultipleViewMode.MonthlyAverages:
        return <MonthlyAverages />;
      case MultipleViewMode.KeyMeasuresOverTime:
        return <KeyMeasuresOverTime chartRef={chartRef} />;
      default:
        return null;
    }
  }

  return null;
};
